/* eslint-disable */
import { HeroLayoutOptions } from '../components/Hero/src/DynamicHero/DynamicHero.types'
import { LayoutConfigsProps } from '../types/LayoutConfigsProps.types'
import { getValueListBgColor, getValueListContrastColor } from './background-util'
import { APIENDPOINT, getCWPEnvironmentForURL } from './common-utils'
import { setTextAlignment } from './text-util'

export const setFlexAlignment = (alignment: string): string => {
  const glyphs = {
    /* from value list */
    left: 'u-lg-flex u-lg-flexAlignItemsStart u-lg-flexJustifyStart',
    center: 'u-lg-flex u-lg-flexAlignItemsCenter u-lg-flexJustifyCenter',
    right: 'u-lg-flex u-lg-flexAlignItemsStart',
    bottomRight: 'u-lg-flex u-lg-flexAlignItemsEnd u-lg-flexJustifyEnd',
    bottomLeft: 'u-lg-flex u-lg-flexAlignItemsEnd',
  }
  if (glyphs[alignment as keyof typeof glyphs]) {
    return glyphs[alignment as keyof typeof glyphs]
  }
  return 'u-lg-flex u-lg-flexAlignItemsStart u-lg-flexJustifyStart'
}

export const setFlexVerticalAlignment = (alignment: string): string => {
  const glyphs = {
    /* from value list */
    verticalRightTop: 'u-lg-flexAlignItemsStart u-lg-flexJustifyCenter',
    verticalLeftTop: 'u-lg-flexAlignItemsStart u-lg-flexJustifyStart',
    verticalRightHeightFull: 'u-lg-flexAlignItemsEnd OverlayHeightFull',
    verticalLeftHeightFull: 'OverlayHeightFull',
    verticalLeftCenter: 'u-flexAlignItemsCenter u-lg-flexJustifyStart',
    verticalRightCenter: 'u-flexAlignItemsCenter u-lg-flexJustifyEnd',
    verticalBottomRight: 'u-lg-flexAlignItemsEnd u-lg-flexJustifyEnd',
  }
  if (glyphs[alignment as keyof typeof glyphs]) {
    return glyphs[alignment as keyof typeof glyphs]
  }
  return 'u-lg-flexAlignItemsStart u-lg-flexJustifyStart' //TopLeft
}

export const setImageBackgroundPosition = (position: string): string => {
  const glyphs = {
    /* from value list */
    contain: 'u-bgSizeContain',
    full: 'u-bgSizeFull',
    bottom: 'u-bgPosBottom',
    top: 'u-bgPosTop',
    left: 'u-bgPosLeft',
    center: 'u-bgPosCenter',
    custom015: 'u-bgPosCustom015',
    cover: 'u-bgSizeCover',
  }
  if (glyphs[position as keyof typeof glyphs]) {
    return glyphs[position as keyof typeof glyphs]
  }
  return 'u-bgSizeContain'
}

export const setVerticalSpacing = (spacing: string): string => {
  let glyphs = {
    'Default': 'u-paddingVert0',
    'No top spacing': 'u-paddingTop0',
    'No bottom spacing': 'u-paddingBottom0',
    'Top 1gu': 'u-paddingTop4',
    'Top 2gu': 'u-paddingTop8',
    'Top 4gu': 'u-paddingTop20',
    'Top 5gu': 'u-paddingTop24',
    'Top 10gu': 'u-paddingTop48',
    'Bottom 1gu': 'u-paddingBottom4',
    'Bottom 2gu': 'u-paddingBottom8',
    'Bottom 4gu': 'u-paddingBottom20',
    'Bottom 5gu': 'u-paddingBottom24',
    'Bottom 10gu': 'u-paddingBottom48',
    'Vertical 2gu': 'u-paddingVert8',
    'Vertical 4gu': 'u-paddingVert20',
    'Vertical 5gu': 'u-paddingVert24',
    'Vertical 10gu': 'u-paddingVert48',
    'Vertical 48': 'u-paddingVert48',
    'None': '',
    'Top Margin 1gu': 'u-marginTop4',
    'Top Margin 2gu': 'u-marginTop8',
    'Top Margin 4gu': 'u-marginTop20',
    'Top Margin 5gu': 'u-marginTop24',
    'Top Margin 10gu': 'u-marginTop48',
    'Bottom Margin 1gu': 'u-marginBottom4',
    'Bottom Margin 2gu': 'u-marginBottom8',
    'Bottom Margin 4gu': 'u-marginBottom20',
    'Bottom Margin 5gu': 'u-marginBottom24',
    'Bottom Margin 10gu': 'u-marginBottom48',
    'Vertical Margin 2gu': 'u-marginVert8',
    'Vertical Margin 4gu': 'u-marginVert20',
    'Vertical Margin 5gu': 'u-marginVert24',
    'Vertical Margin 10gu': 'u-marginVert48',
  }
  const space = glyphs[spacing as keyof typeof glyphs]
  return space || ''
}

export const setConfigVertSpacing = (layoutConfigs: { verticalSpacing?: string } = {}): string => {
  if (layoutConfigs.verticalSpacing) {
    return ' ' + setVerticalSpacing(layoutConfigs.verticalSpacing)
  } else {
    return ' u-paddingVert48 '
  }
}

export const setConfigBgColorClass = (
  layoutConfigs: { globalBgColor?: { color?: string } } = {}
): string => {
  return layoutConfigs.globalBgColor && layoutConfigs.globalBgColor.color
    ? getValueListBgColor(layoutConfigs.globalBgColor.color)
    : ''
}

export const setBgContrastClass = (
  layoutConfigs: { globalBgColor?: { color?: string } } = {}
): string => {
  return layoutConfigs.globalBgColor && layoutConfigs.globalBgColor.color
    ? getValueListContrastColor(layoutConfigs.globalBgColor.color)
    : ''
}

export const setContentAlignment = (
  layoutConfigs: { textAlignment?: { alignment?: string } } = {}
): string => {
  if (layoutConfigs && layoutConfigs?.textAlignment?.alignment) {
    return ' ' + setTextAlignment(layoutConfigs.textAlignment.alignment)
  } else {
    return ' u-textLeft '
  }
}
export const setLayoutAlignment = (layout: HeroLayoutOptions, column: 'right' | 'left'): string => {
  switch (layout) {
    case '50 - 50': {
      return 'u-size6of12'
    }
    case '67 - 33': {
      if (column === 'left') {
        return 'u-size8of12'
      }
      return 'u-size4of12'
    }
    default: {
      return 'u-size12of12'
    }
  }
}
const env = getCWPEnvironmentForURL(window.location.href)
export const setBackgroundImage = (layoutConfigs: LayoutConfigsProps = {}): string => {
  const color = layoutConfigs?.globalBgColor?.color
  let bgImage = ''
  if (color === 'white-facets-top' || color === 'white-facets-bottom') {
    const isCareers = window.location.href.includes('careers')
      ? 'content/gallery/joinameriprise/'
      : 'content/gallery/ampmicrosites/'
    bgImage = APIENDPOINT(env).baseGallery + isCareers + color + '.jpg'
  }
  return bgImage
}
